/* eslint-disable react-refresh/only-export-components */
import { NavigateFunction, useNavigate, useParams } from 'react-router';
import { t } from '../../../translations/i18n';
import { getRouteByPath, ROUTES } from '../../../app/routes';
import Operations from '../../../icons/Operations.svg?react';
import Delete from '../../../icons/Delete.svg?react';


import { MikeLayerActionMenu } from '../../../shared/layers/actions/layer-action-menu';
import { ILayerAction } from '../../../shared/layers/actions/layer-default-actions';


type GeometryMultipleActionsProps = {
  canApplyOperations?: boolean;
};

/**
 * @name MmgConnectedGeometryMultipleActions
 * @summary Geometry multi-selection actions.
 *
 * @param props
 */
export function MmgConnectedGeometryMultipleActions(props: GeometryMultipleActionsProps) {
  const { canApplyOperations = true } = props;

  const { workspaceId, projectId } = useParams();
  const navigate = useNavigate();
  const layerActions = getLayerActions(
    projectId,
    workspaceId,    
    canApplyOperations,
    navigate
  );

  return <MikeLayerActionMenu layerId="multi-geometries" layerActions={layerActions} />;
}

const getLayerActions = (projectId: string, workspaceId: string, canApplyOperations: boolean, navigate: NavigateFunction) => {
  const layerActions = [];

  if (canApplyOperations) {
    const geometryOperationAction = getGeometriesOperationAction(projectId, workspaceId, navigate, false);

    layerActions.push(geometryOperationAction);
  }

  const deleteLayerAction = getDeleteGeometriesAction(projectId, workspaceId, navigate, false);

  layerActions.push(deleteLayerAction);

  return layerActions;
};

export const getDeleteGeometriesAction = (projectId: string, workspaceId: string, navigate: NavigateFunction, disabled?: boolean): ILayerAction => {
  const onDelete = () => {
    return navigate(getRouteByPath(ROUTES.geometriesDeletePanel.path, { workspaceId, projectId }, ROUTES.workspace.path));
  };

  const deleteLayersAction = {
    actionId: 'GEOMETRIES_DELETE',
    actionDisplayName: t('GEOMETRIES_DELETE'),
    actionIcon: <Delete />,
    onAction: () => onDelete(),
    disabled,
  };

  return deleteLayersAction;
};

export const getGeometriesOperationAction = (
  projectId: string,
  workspaceId: string,
  navigate: NavigateFunction,
  disabled?: boolean,
): ILayerAction => {
  const onOperation = () => {
    return navigate(getRouteByPath(ROUTES.geometriesOperationSelectItemsPanel.path, { workspaceId, projectId }, ROUTES.workspace.path));     
  };

  const operationLayerAction = {
    actionId: 'GEOMETRY_OPERATIONS',
    actionDisplayName: t('GEOMETRY_OPERATIONS'),
    actionIcon: <Operations />,
    onAction: () => onOperation(),
    disabled,
  };

  return operationLayerAction;
};
